import { render, staticRenderFns } from "./PolicyDiscountDescription.vue?vue&type=template&id=11a31632"
import script from "./PolicyDiscountDescription.vue?vue&type=script&lang=ts"
export * from "./PolicyDiscountDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports